import React, { useEffect, useState } from 'react';

import infoKnockoutTokens from '@amzn/meridian-tokens/base/icon/info-knockout';
import Alert from '@amzn/meridian/alert';
import Link from '@amzn/meridian/link';
import Text from '@amzn/meridian/text';
import { ASSOCIATE_PROFILE_BASEURL } from 'src/constants/Routes';
import associateProfileService from 'src/services/associateProfile/associateProfileService';
import { useAppSelector } from 'src/store/store';
import { ignoreCancelError } from 'src/utils/apiClient';
import { JmrFlowTypes } from 'src/utils/jmrUtils';

const PlacementCountAlert = () => {
  const { jmrFlowType, backgroundFormData } = useAppSelector((state) => state.newJmrPage);
  const [placementCount, setPlacementCount] = useState<number>(0);

  const activePlacementCount =
    jmrFlowType === JmrFlowTypes.CreateNewAccommodation ? placementCount : placementCount - 1;

  useEffect(() => {
    const controller = new AbortController();

    const fetchPlacements = async () => {
      if (!backgroundFormData.alias || !backgroundFormData.site.id) {
        setPlacementCount(0);
        return;
      }

      try {
        const { data: placements } = await ignoreCancelError(
          associateProfileService.getAssociateProfilePlacements(backgroundFormData.alias, backgroundFormData.site.id, {
            signal: controller.signal,
          }),
          controller.signal,
        );
        setPlacementCount(placements.pending.length + placements.active.length + placements.transferredIn.length);
      } catch (error) {
        console.error('Failed to fetch associate profile placements', error);
      }
    };

    fetchPlacements();

    return () => {
      controller.abort();
    };
  }, [backgroundFormData.alias, backgroundFormData.site.id]);

  if (activePlacementCount <= 0) return null;

  return (
    <Alert type="theme" iconTokens={infoKnockoutTokens}>
      <Text type="b200">
        <b>{activePlacementCount} Active Placements.</b>&nbsp;
        <Link
          href={`${ASSOCIATE_PROFILE_BASEURL}/${backgroundFormData.alias}/restrictions?site=${backgroundFormData.site.site}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          See details
        </Link>
      </Text>
    </Alert>
  );
};

export default PlacementCountAlert;
